export default __webpack_public_path__ + "static/media/digivakuusEligible.7ba6d044.svg";